'use client';
import { NewsCard } from '@/app/Components/Element_Components/newsCard/NewsCard';
import { useEffect, useState, useCallback } from 'react';
import LinkWithArrow from '../../Element_Components/linkWithArrow/linkWithArrow';
import { useLanguage } from '@/app/LanguageContext';
import fetchNews from './fetchNews';
import formatDate from '@/utils/formatDate';
import { getPublicBaseUrl } from '@/lib/getBaseURL';
import { useTranslate } from '@/utils/languageTranslation';

interface NewsItem {
  id: number; // Assuming 'id' is the unique identifier from Strapi
    category: string | null;
    headline: string | null;
    documentId: string;
    publishDate: string | null;
    newsThumbnail?: {
          url: string;
      }
}

interface NewsResponse {
  data: NewsItem[];
}

export const NewsSection = () => {
  const {t} = useTranslate()
  const [news, setNews] = useState<
  {
    documentId: string;
    thumbnailImage:{
      url: string;
    }
    category: string;
    title: string;
    publishDate: string;
  }[]
>([]);
 useEffect(() => {
     fetchNews().then((data) => {
      const formattedNews = data.map((item) => ({
        documentId: item.documentId,
        thumbnailImage: item.newsThumbnail,
        category: item.category,
        title: item.headline,
        publishDate: item.publishedAt,
      }));
      setNews(formattedNews);
    })
 }, []);
  

  return (
    <section className="py-12 flex flex-col items-center justify-center px-5 my-10">
      {/* Centered Title */}
      <div className='flex md:flex-row flex-col w-full md:max-w-[71rem] justify-between mb-5'>
        <div className=' flex flex-col items-center md:items-start'>
          <h2 className="text-2xl md:text-3xl font-bold md:text-start mb-4">{t('latest_news')}</h2>
          {/* Subcategory */}
          <p className="text-base md:text-lg text-gray-600 text-center md:text-start mb-12">
          {t('stay_up_to_date')}
          </p>
        </div>
        

        {/* Grid of Cards */}
        <div className='flex items-center justify-center'>
          <div className="flex justify-end   mb-5">
            <LinkWithArrow href="/news" text={t('news')} />
          </div>
        </div>
        
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 max-w-[71rem] mx-auto justify-between">
        {news.slice(0, 3).map((newsItem) => (
          <NewsCard
            key={newsItem.documentId}
            href={`/newsDetail/${newsItem.documentId}`}
            featuredImage={`${getPublicBaseUrl()}${newsItem.thumbnailImage?.url}`}
            category={newsItem.category}
            title={newsItem.title}
            publishDate={formatDate(newsItem.publishDate)}
            className="w-full"
          />
        ))}
      </div>
    </section>
  );
};